import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ccd-markdown',
  template: require('./markdown.html')
})
export class MarkdownComponent implements OnInit {

  @Input()
  content: string;

  ngOnInit(): void {
    this.content = this.content.replace(/  \n/g, '<br>');
  }
}
